export const getAuthGroupsFromString = (groupIdString: string) =>
  groupIdString.split("|");
